<!-- 3d模型 -->
<template>
  <div id="three">

    <div style="background-color:#333;position: absolute;right:0;top:0;font-size: 20px;color:#fff;padding:5px 10px;" v-if="isConsole">x:{{c_x}},y:{{c_y}},z:{{c_z}}</div>

    <div style="position: absolute;right: 120px;top: 16px;z-index: 25;">
      <a-button type="primary" @click="toggleMaterial" size="small">
        切换材质
      </a-button>
    </div>

    <div id="chooseFrame" style="position: absolute;left: 10px;top: 10px;background-color: aliceblue;padding:5px;font-weight: bolder;">

    <a-checkbox @change="onChange" :checked="checkFrame">
      {{$t('components.outline')}}
    </a-checkbox>

    <a-button type="primary" size="small" @click="reset" style="margin-left: 10px;">
      {{$t('components.reset')}}
    </a-button>

    </div>

  </div>
 
</template>

<script>
import * as Three from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import {CSG} from "./three-csg.js"
import { min } from "moment";


var myCamera = null
var myScene = null
var container = null

var vector = new Three.Vector2();//三维坐标对象

var rayPoints = null


var raycaster = new Three.Raycaster();

var data_points= null
var data_index = null

var meshResult = null
var material111 = null
var gradientMaterial = null
var coneMaterialGlobal = null  // Store cone material reference

var points = null

var errorAnomalies = null
var errorPoints = null


export default {
  name: "",
  props: ["datas","chang","kuan","gao","xiazhui","height","ckjg","lszl","isConsole","errorData","errorCode"],

  data() {
    return {
      camera: null,
      scene: null,
      renderer: null,
      mesh: null,
      pointCloudGeometry:null,
      pointCloud:null,
      material:null,
      cPoints:null,
      //粮面高度(锥体上开始计算)
      grainHeight: 410,
      bottomHeight: 80,

      // 窗口尺寸变化
      screenWidth: null,
      timer: null,
      checkFrame:true,  // 默认显示外框
      checkHot:true,


      GLTFobjects:null,
      GLTFobjects0:null,
      myControl:null,
      flowLightMaterial: null,  // 流光效果材质引用，用于更新 time uniform
      flowClock: null,          // Three.Clock 实例

      checkMesh:true,
      checkPoints:false,  // 默认不加载点云
      checkErrorData:true,

      useWheatTexture:false,  // Track current texture state
      isTransitioning:false,  // Track if material transition is in progress


      //点坐标
      c_x:0,
      c_y:0,
      c_z:0
    };
  },
  methods: {

    onChange(e) {

      this.checkFrame = e.target.checked

      console.log(`checked = ${e.target.checked}`);

      this.GLTFobjects.visible = this.checkFrame;
      if(this.GLTFobjects0!=null){
        this.GLTFobjects0.visible = this.checkFrame;
      }
      
    },

    //meshResult的显示与隐藏
    onToggleMesh(e){
      this.checkMesh = e.target.checked
      meshResult.visible = this.checkMesh
    },

    onTogglePoints(e){
      this.checkPoints = e.target.checked
      points.visible = this.checkPoints
    },

    onToggleErrorData(e){
      this.checkErrorData = e.target.checked
      if(typeof errorAnomalies !== 'undefined' && errorAnomalies){
        errorAnomalies.forEach(anomaly => {
          anomaly.visible = this.checkErrorData;
        });
      }
      if(typeof errorPoints !== 'undefined' && errorPoints){
        errorPoints.forEach(points => {
          points.visible = this.checkErrorData;
        });
      }
    },

    toggleMaterial() {
      // Prevent multiple transitions at once
      if (this.isTransitioning) return;
      
      this.isTransitioning = true;
      this.useWheatTexture = !this.useWheatTexture;
      
      // Determine transition direction: 
      // To wheat = bottom-up (1.0), To strip = top-down (-1.0)
      const direction = this.useWheatTexture ? 1.0 : -1.0;
      
      // Set target material and direction
      if (gradientMaterial) {
        gradientMaterial.uniforms.useWheatMaterial.value = this.useWheatTexture ? 1.0 : 0.0;
        gradientMaterial.uniforms.transitionDirection.value = direction;
        gradientMaterial.uniforms.transitionProgress.value = 0.0;
      }
      
      if (coneMaterialGlobal) {
        coneMaterialGlobal.uniforms.useWheatMaterial.value = this.useWheatTexture ? 1.0 : 0.0;
        coneMaterialGlobal.uniforms.transitionDirection.value = direction;
        coneMaterialGlobal.uniforms.transitionProgress.value = 0.0;
      }
      
      // Animation parameters
      const duration = 1500; // 1.5 seconds
      const startTime = performance.now();
      
      const animate = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1.0);
        
        // Easing function (ease-in-out)
        const eased = progress < 0.5 
          ? 2 * progress * progress 
          : 1 - Math.pow(-2 * progress + 2, 2) / 2;
        
        // Update transition progress
        if (gradientMaterial) {
          gradientMaterial.uniforms.transitionProgress.value = eased;
        }
        
        if (coneMaterialGlobal) {
          coneMaterialGlobal.uniforms.transitionProgress.value = eased;
        }
        
        if (progress < 1.0) {
          requestAnimationFrame(animate);
        } else {
          this.isTransitioning = false;
        }
      };
      
      requestAnimationFrame(animate);
    },


    onChangeHot(e) {

    this.checkHot = e.target.checked

    console.log(`checked = ${e.target.checked}`);

    if(this.checkHot){
      meshResult.material = gradientMaterial;
    }else{
      meshResult.material = material111;
    }

    },

    reset(){
      this.myControl.reset();
    },

    init() {
      // console.log("??",controls);
      container = document.getElementById("three");

      this.scene  =  new Three.Scene();
      myScene = this.scene
      //this.scene.position(200,200,200)
      var directionalLight = new Three.DirectionalLight(0xffffff, 5);
      directionalLight.name = "directionalLight";
      //directionalLight.position.set(0, 100, 0);
      this.scene.add(directionalLight);

      
      this.camera  =new Three.PerspectiveCamera(
        45, window.innerWidth / window.innerHeight,100, 10000);

     
        

      this.camera.position.z = 0;
      this.camera.position.y = 1800
      this.camera.position.x = 0;
      this.scene.add(this.camera);
      this.renderer = new Three.WebGLRenderer({
        antialias: false,
        logarithmicDepthBuffer: true,
      });
      var control = new OrbitControls(this.camera, this.renderer.domElement);

      
      // control.minDistance = 300;
      // control.maxDistance = 1000;

      control.update();

      

      myCamera = this.camera


      this.renderer.setClearColor(0xffffff);
      this.renderer.setPixelRatio(window.devicePixelRatio);
      this.renderer.outputEncoding = Three.sRGBEncoding;
      this.renderer.physicallyCorrectLights = true;
      this.renderer.toneMapping = Three.ACESFilmicToneMapping;
      this.renderer.toneMappingExposure = 1.5;
      this.renderer.setSize(container.clientWidth, container.clientHeight);

      // 加载 HDR 环境贴图 (夜空)
      this.loadEnvironmentMap();

      // let geometry = new Three.CylinderBufferGeometry(0.2, 0.2, 0.2);

      // let material = new Three.MeshNormalMaterial();

      // this.mesh = new Three.Mesh(geometry, material);
      // 防止重复渲染
      if (container.children.length > 0) {
        //container.removeChild(container.children[0]);
      }
      container.appendChild(this.renderer.domElement);
      // 创建环绕场景的炫酷流光效果
      this.createFlowLightEffect();
      // 加载场景模型
      this.initContent();

      this.myControl = control

    },




     //选择一个物体
 onDocumentMouseDown( event ) {




vector.x = ((event.clientX - container.getBoundingClientRect().left) / container.offsetWidth) * 2 - 1
vector.y = -((event.clientY - container.getBoundingClientRect().top) / container.offsetHeight) * 2 + 1

raycaster.setFromCamera(vector,this.camera)

      const intersects = raycaster.intersectObjects(this.scene.children)

      if (intersects.length > 0) {
        var selected = intersects[0];//取第一个物体
        
        console.log("x坐标:" + selected.point.x);
        console.log("y坐标:" + selected.point.y);
        console.log("z坐标:" + selected.point.z);
        console.log(selected)
        //比较与所有点云的点的距离
        console.log("类型",typeof selected)
        console.log("index",selected.index)
        if(!!selected.index){
          data_index = selected.index

          console.log(data_points[data_index])

          let ptArr = data_points[data_index].split(",")

          this.c_x = ptArr[0]
          this.c_y = ptArr[1]
          this.c_z = ptArr[2]

        }
        


        if(!!rayPoints){
          this.scene.remove(rayPoints)
        }
      
        //创建一个立方体几何对象Geometry
        var geometry11 = new Three.BoxGeometry(4, 4, 4);
        //给几何体创建材质，这里是改为蓝色，材质对象Material
        var material11 = new Three.MeshLambertMaterial({
            color: 0x00ff00
        });
        //网格模型对象Mesh
        var mesh = new Three.Mesh(geometry11, material11);
        //mesh.position.set(selected.point.x-this.chang/2, selected.point.y-this.gao, selected.point.z-this.chang/2 )
        mesh.position.set(selected.point.x, selected.point.y, selected.point.z  )
        //网格模型添加到场景中，每个模型最终都要添加到场景中才会被渲染
        rayPoints = mesh
        this.scene.add(rayPoints);

      }
 

},


    // 加载场景模型
    initContent() {

      // 加载 glTF 格式的模型
     
      this.loadData(this.normalizePointData(this.datas))
      
    },
    renderScene() {
      requestAnimationFrame(this.renderScene);

      // 更新流光效果的时间 uniform
      if (this.flowLightMaterial && this.flowClock) {
        this.flowLightMaterial.uniforms.time.value = this.flowClock.getElapsedTime();
      }
      this.renderer.render(this.scene, this.camera);
    },
    getTexture(png) {
      var texture = new Three.TextureLoader().load(png);
      return texture;
    },


    normalizePointData(data) {
      if (Array.isArray(data)) {
        return data.flat(Infinity).join(',');
      }
      if (typeof data === 'string') {
        return data;
      }
      if (data && typeof data === 'object') {
        const candidates = [
          data.pointData,
          data.data,
          data.points,
          data.total_points,
          data.point_data,
        ];
        for (let i = 0; i < candidates.length; i++) {
          const normalized = this.normalizePointData(candidates[i]);
          if (normalized && normalized.trim()) return normalized;
        }
      }
      return '';
    },

    // 创建连续的“圆柱仓体 + 下锥”裁剪体。
    // 下锥顶口与圆柱底部只共享一圈顶点，不生成 Y=0 的内部底面，
    // 避免混合高度粮面做 CSG 时在下锥顶口产生水平封口。
    createRoundSiloClipGeometry(radius, bodyHeight, coneHeight, radialSegments = 100) {
      const positions = [];
      const indices = [];
      const segments = Math.max(12, radialSegments);

      for (let i = 0; i < segments; i++) {
        const angle = (i / segments) * Math.PI * 2;
        const x = Math.cos(angle) * radius;
        const z = Math.sin(angle) * radius;
        positions.push(x, 0, z);
        positions.push(x, bodyHeight, z);
      }

      const topCenterIndex = positions.length / 3;
      positions.push(0, bodyHeight, 0);
      const coneApexIndex = positions.length / 3;
      positions.push(0, -coneHeight, 0);

      for (let i = 0; i < segments; i++) {
        const next = (i + 1) % segments;
        const bottom = i * 2;
        const top = bottom + 1;
        const nextBottom = next * 2;
        const nextTop = nextBottom + 1;

        // 圆柱侧壁
        indices.push(bottom, top, nextBottom);
        indices.push(nextBottom, top, nextTop);
        // 圆柱顶面
        indices.push(topCenterIndex, nextTop, top);
        // 下锥侧壁；顶口处不加水平底面
        indices.push(coneApexIndex, bottom, nextBottom);
      }

      const clipGeometry = new Three.BufferGeometry();
      clipGeometry.setAttribute(
        'position',
        new Three.Float32BufferAttribute(positions, 3)
      );
      clipGeometry.setIndex(indices);
      clipGeometry.computeVertexNormals();
      return clipGeometry;
    },

    loadData(data){

      let that = this
      data = this.normalizePointData(data);
      if (!data) {
        console.warn('roundModel loadData skipped: empty point data');
        return;
      }

      let max_y = -10000 //最高点初始化
     
      let loader = new GLTFLoader(); /*实例化加载器*/
      const geometry = new Three.BufferGeometry();

      const positions = [];
      const fillPositions = [];
      const colors = [];
      const fillColors = []

      const color = new Three.Color();
      console.log("print data:",data)

      let ptArr1 = data.split(",");
      let spArr = []
				let arrTmp = []
        let arr02 = null
				for(let i=0;i<=ptArr1.length-1;i=i+3){

					arrTmp.push(ptArr1[i]+","+ptArr1[i+1]+","+ptArr1[i+2])
				}

        arr02 = arrTmp
        data_points = arr02 
        let indexArr = []
				//let type = "平房仓"
				let type = "圆筒仓"

        let maxY = -Infinity;
            let minY = Infinity;
            
            for ( let i = 0; i < arr02.length-1; i ++ ) {
                let pt0 =  arr02[i].split(",");
                const x = (pt0[0]);
                let y = (pt0[2]);
                const z = ((pt0[1]));
                 // 如果y小于等于0，将y值置为0.01
                // 如果y小于等于0，将y值置为0.01
                if (y <= 0) {
                    y = 0.01;
                }
                if(y<0.01 && y>0){
                    y = 0.01;
                }
                
                let step = parseInt(y);
                const yFloat = parseFloat(y);  // 使用浮点值计算真实的 min/max
                
                // Update max and min Y values (使用浮点值而非取整值)
                maxY = Math.max(maxY, yFloat);
                minY = Math.min(minY, yFloat);
                
                positions.push( x, y, z );
                indexArr.push(new Three.Vector3( x, yFloat, z ))
                // colors
                color.setRGB( 255, 204, 0 );
                colors.push( color.r, color.g, color.b );
            }
            
            // 保存真实高度范围，用于判断粮面与下锥顶口的相对位置。
            // minY 后续会为了颜色边界向下扩展，不能再用于几何分支判断。
            const surfaceMinY = minY;
            const surfaceMaxY = maxY;

            // 向下取整并减1，确保边界正确
            minY = Math.floor(minY) - 1;
            
            console.log("最高点 (浮点):", maxY);
            console.log("最低点 (向下取整-1):", minY);
            console.log("Y范围:", maxY - minY);

            max_y = maxY
        
          console.log("點",positions)

          let showSize = 1.0;

				if(this.lszl == "玉米"){
					showSize = 5.0;
				}

				if(this.lszl == "小麦"){
					showSize = 2.0;
				}

				if(this.isConsole){
					showSize = 7.5;
				}

				// Set geometry attributes
				geometry.setAttribute('position', new Three.Float32BufferAttribute(positions, 3));
				geometry.setAttribute('color', new Three.Float32BufferAttribute(colors, 3));

				// Create texture loader and load point texture
				const textureLoader = new Three.TextureLoader();
				const pointTexture = textureLoader.load('/disc.png'); // Assuming point texture exists

				// Create custom shader material
				const shaderMaterial = new Three.ShaderMaterial({
					uniforms: {
						pointTexture: { value: pointTexture },
						pointSize: { value: showSize },
						time: { value: 0 },
						maxY: { value: maxY }, // Add maxY uniform
						minY: { value: minY }, // Add minY uniform
						belowMinColor: { value: new Three.Color(0.0, 0.2, 0.8) }, // 深蓝色
						colorCold1: { value: new Three.Color(0.0, 0.2, 0.8) },    // 深蓝色
						colorCold2: { value: new Three.Color(0.0, 0.5, 0.9) },    // 浅蓝色
						colorNeutral: { value: new Three.Color(0.7, 0.7, 0.7) },  // 中性灰色
						colorWarm1: { value: new Three.Color(0.9, 0.5, 0.0) },    // 橙色
						colorWarm2: { value: new Three.Color(1.0, 0.2, 0.0) }     // 红色
					},
					
					vertexShader: `
						uniform float pointSize;
						uniform float maxY;
						uniform float minY;
						varying vec3 vColor;
						varying float vHeight;
						varying float vActualY;
						
						void main() {
							// Use actual min/max Y values from uniforms
							vHeight = (position.y - minY) / (maxY - minY);
							vActualY = position.y;
							vColor = color;
							vec4 mvPosition = modelViewMatrix * vec4(position, 1.0);
							gl_PointSize = pointSize * (300.0 / -mvPosition.z);
							gl_Position = projectionMatrix * mvPosition;
              gl_Position.y += 0.001;
						}
					`,
					fragmentShader: `
						uniform sampler2D pointTexture;
						uniform float minY;
						uniform vec3 belowMinColor;
						uniform vec3 colorCold1;
						uniform vec3 colorCold2;
						uniform vec3 colorNeutral;
						uniform vec3 colorWarm1;
						uniform vec3 colorWarm2;
						varying vec3 vColor;
						varying float vHeight;
						varying float vActualY;
						
						vec3 getHeightColor(float t) {
							if(t < 0.25) {
								return mix(colorCold1, colorCold2, t * 4.0);
							} else if(t < 0.5) {
								return mix(colorCold2, colorNeutral, (t - 0.25) * 4.0);
							} else if(t < 0.75) {
								return mix(colorNeutral, colorWarm1, (t - 0.5) * 4.0);
							} else {
								return mix(colorWarm1, colorWarm2, (t - 0.75) * 4.0);
							}
						}
						
						void main() {
							vec4 texColor = texture2D(pointTexture, gl_PointCoord);
							if(texColor.a < 0.5) discard;
							
							vec3 finalColor;
							
							// 如果点的实际Y坐标小于minY，使用#FF6600颜色
							if(vActualY < minY) {
								finalColor = belowMinColor;
							} else {
								// minY到maxY之间使用多级颜色渐变
								float t = clamp(vHeight, 0.0, 1.0);
								t = smoothstep(0.0, 1.0, t);
								finalColor = getHeightColor(t);
							}
							
							float edge = smoothstep(0.4, 0.5, texColor.a);
							gl_FragColor = vec4(finalColor, edge);
						}
					`,
					transparent: true,
					vertexColors: true,
				});

				// Create points with custom shader material
				points = new Three.Points(geometry, shaderMaterial);
				points.frustumCulled = false;
				points.visible = this.checkPoints;  // 默认不显示点云
				this.scene.add(points);


const axesHelper = new Three.AxesHelper(100)
//this.scene.add(axesHelper)


points.position.set(-this.chang*0.5, -this.kuan, -this.chang*0.5)

//添加平面
// triangulate x, z
var indexDelaunay = Delaunator.from(
    indexArr.map(v => {
      return [v.x, v.z];
    })
);


var meshIndex = []; // delaunay index => three.js index
for (let i = 0; i < indexDelaunay.triangles.length; i++){

  meshIndex.push(indexDelaunay.triangles[i]);
}


var geom = new Three.BufferGeometry().setFromPoints(indexArr);
geom.setIndex(meshIndex); // add three.js index to the existing geometry
geom.computeVertexNormals();
var mesh0 = new Three.Mesh(
    geom, // re-use the existing geometry
    new Three.MeshBasicMaterial({ color: "#FF6600", wireframe: false,side:Three.DoubleSide })
);



//this.scene.add(mesh0);

mesh0.position.set(-this.chang*0.5,-this.kuan,-this.chang*0.5)

mesh0.scale.set(1.15,1,1.15)
mesh0.position.set(0.15*mesh0.position.x-this.chang*0.5,-this.kuan,0.15*mesh0.position.z-this.chang*0.5)

//添加立方体

//长、框、高、下锥

let w_height = this.gao*0.5;
let w_width = this.kuan*0.5;
let w_length = this.chang*0.5;
let w_xiazhui = this.kuan*0.5;

//this.scene.position.set(w_length, w_height*2, w_length)
var axes = new Three.AxesHelper(4000);
      // axes.position.x = w_length;
      // axes.position.y = w_height*2;
      // axes.position.z = w_length;
      //this.scene.add(axes);

      console.log('max_y',max_y)

      // 点云原始高度包含下锥高度；mesh0 再整体下移 kuan，
      // 因此原始高度 kuan 对应下锥顶口的世界坐标 Y=0。
      // 使用局部状态，避免多个筒仓实例之间残留 down_flag。
      const down_flag = surfaceMaxY < this.kuan;
      const crossesConeTop = surfaceMinY < this.kuan && surfaceMaxY >= this.kuan;


var warehouse = new Three.BoxGeometry(w_width, w_height, w_length);
var material_w = new Three.MeshBasicMaterial({
  color: 0xfff
});
var cube = new Three.Mesh(warehouse, material_w);
//scene.add(cube);


//定义shaderMaterial

const sdMaterial = new Three.ShaderMaterial({
  vertexShader:`
    varying vec3 vNormal;
    varying vec3 vPosition;
    void main(){
      vec4 modelPosition = modelMatrix * vec4(position,1.0);
      vec4 viewPosition = viewMatrix * modelPosition;
      vec4 projectedPosition = projectionMatrix * viewPosition;
      gl_Position = projectedPosition;
      vec3 modelNormal = (modelMatrix * vec4(normal,0.0)).xyz;
      vNormal = modelNormal;
      vPosition = modelPosition.xyz;
    }
  `,

  fragmentShader:`
    varying vec3 vNormal;
    varying vec3 vPosition;
    void main(){
      //Frenel
      vec3 viewDirection = normalize(vPosition - cameraPosition);
      vec3 normal = normalize(vNormal);
      float fresnel = dot(viewDirection,normal)+1.0;
      fresnel = pow(fresnel,2.0);
      gl_FragColor = vec4(vec3(fresnel),1.0);
      
    }
  
  `,
  
})

//添加gltf

console.log('xiazhui',w_xiazhui)

// Create custom semi-transparent material for outline frames
// Pure color without lighting effects
const outlineFrameMaterial = new Three.ShaderMaterial({
  uniforms: {
    color: { value: new Three.Color(0.6, 0.55, 0.45) },
    opacity: { value: 0.5 }
  },
  vertexShader: `
    void main() {
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
  `,
  fragmentShader: `
    uniform vec3 color;
    uniform float opacity;
    void main() {
      gl_FragColor = vec4(color, opacity);
    }
  `,
  transparent: true,
  depthWrite: false,
  depthTest: true,
  side: Three.DoubleSide,
  blending: Three.NormalBlending
});

  if(w_xiazhui == 0){
    loader.load( '/hxc_model/cylinder_m.gltf', function ( gltf ) {

      gltf.scene.scale.set(w_length,w_height,w_length)
      gltf.scene.traverse( function ( child ) {
        if ( child.isMesh ) {
          // Replace with custom material
          child.material = outlineFrameMaterial.clone();
          child.renderOrder = 10;  // Render after opaque objects
        }})

      that.scene.add( gltf.scene )
      that.GLTFobjects = gltf.scene
      gltf.scene.position.set(-w_length, 0, -w_length)
      gltf.scene.visible = that.checkFrame;  // Set initial visibility based on checkbox state
      //render();

    } );
  }else{

    loader.load( '/hxc_model/cylinder_m.gltf', function ( gltf ) {
      gltf.scene.scale.set(w_length,w_height,w_length)
      gltf.scene.traverse( function ( child ) {
        if ( child.isMesh ) {
          child.material = outlineFrameMaterial.clone();
          child.renderOrder = 10;
        }})
      that.scene.add( gltf.scene );
      that.GLTFobjects = gltf.scene
      gltf.scene.position.set(-w_length, 0, -w_length)
      gltf.scene.visible = that.checkFrame;  // Set initial visibility based on checkbox state
      
    } );

    loader.load( '/hxc_model/cylinder_x.gltf', function ( gltf ) {
      gltf.scene.scale.set(w_length,w_xiazhui,w_length)
      gltf.scene.traverse( function ( child ) {
        if ( child.isMesh ) {
          child.material = outlineFrameMaterial.clone();
          child.renderOrder = 10;
        }})

      that.scene.add( gltf.scene );
      that.GLTFobjects0 = gltf.scene
      gltf.scene.position.set(-w_length, 0, -w_length)
      gltf.scene.visible = that.checkFrame;  // Set initial visibility based on checkbox state
    } );
  }



  const cGroup = new Three.Group()


  if(!this.isConsole){
  //布尔运算
var geometry111 = new Three.CylinderGeometry( w_length,  w_length,w_height*2,50,50,false );  // 盒子几何体
material111 = new Three.MeshBasicMaterial( { color: 0xFF6600 } );  // 一种材料，设置集合体颜色
var cube111 = new Three.Mesh( geometry111, material111 );  // 网格，也就是几何体

// Load textures for cone material
const coneTextureLoader = new Three.TextureLoader();
const coneStripDiffuse = coneTextureLoader.load('/hxc_model/strip_diffuse.jpg');
const coneStripNormal = coneTextureLoader.load('/hxc_model/strip_normal.jpg');

// Set texture wrapping and repeat for cone
coneStripDiffuse.wrapS = coneStripDiffuse.wrapT = Three.RepeatWrapping;
coneStripNormal.wrapS = coneStripNormal.wrapT = Three.RepeatWrapping;
coneStripDiffuse.repeat.set(4, 4);
coneStripNormal.repeat.set(4, 4);

// Create textured material for cone
const coneMaterial = new Three.ShaderMaterial({
  uniforms: {
    stripDiffuseMap: { value: coneStripDiffuse },
    stripNormalMap: { value: coneStripNormal },
    useWheatMaterial: { value: 0.0 },  // 0 = strip, 1 = wheat (procedural)
    transitionProgress: { value: 0.0 },  // 0-1 transition progress
    transitionDirection: { value: 1.0 }, // 1 = bottom-up, -1 = top-down
    modelMinY: { value: -500.0 },  // Model min Y bound
    modelMaxY: { value: 500.0 }    // Model max Y bound
  },
  vertexShader: `
    varying vec2 vUv;
    varying vec3 vPosition;
    varying vec3 vNormal;
    varying vec3 vWorldPosition;
    
    void main() {
      vPosition = position;
      vec4 worldPosition = modelMatrix * vec4(position, 1.0);
      vWorldPosition = worldPosition.xyz;
      vUv = vec2(worldPosition.x * 0.1, worldPosition.z * 0.1);
      vNormal = normalize(normalMatrix * normal);
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
  `,
  fragmentShader: `
    uniform sampler2D stripDiffuseMap;
    uniform sampler2D stripNormalMap;
    uniform float useWheatMaterial;
    uniform float transitionProgress;
    uniform float transitionDirection;
    uniform float modelMinY;
    uniform float modelMaxY;
    varying vec2 vUv;
    varying vec3 vPosition;
    varying vec3 vNormal;
    varying vec3 vWorldPosition;
    
    // Hash function for randomness
    float hash(vec3 p) {
      p = fract(p * 0.3183099 + 0.1);
      p *= 17.0;
      return fract(p.x * p.y * p.z * (p.x + p.y + p.z));
    }
    
    // 3D Noise function
    float noise(vec3 x) {
      vec3 i = floor(x);
      vec3 f = fract(x);
      f = f * f * (3.0 - 2.0 * f);
      
      return mix(mix(mix(hash(i + vec3(0,0,0)), hash(i + vec3(1,0,0)), f.x),
                     mix(hash(i + vec3(0,1,0)), hash(i + vec3(1,1,0)), f.x), f.y),
                 mix(mix(hash(i + vec3(0,0,1)), hash(i + vec3(1,0,1)), f.x),
                     mix(hash(i + vec3(0,1,1)), hash(i + vec3(1,1,1)), f.x), f.y), f.z);
    }
    
    // Fractal Brownian Motion for more detail
    float fbm(vec3 p) {
      float value = 0.0;
      float amplitude = 0.5;
      float frequency = 1.0;
      for(int i = 0; i < 4; i++) {
        value += amplitude * noise(p * frequency);
        amplitude *= 0.5;
        frequency *= 2.0;
      }
      return value;
    }
    
    // Voronoi-like pattern for wheat grains
    float wheatGrains(vec3 p, float scale) {
      p *= scale;
      vec3 i = floor(p);
      vec3 f = fract(p);
      
      float minDist = 1.0;
      vec3 minPoint = vec3(0.0);
      
      for(int x = -1; x <= 1; x++) {
        for(int y = -1; y <= 1; y++) {
          for(int z = -1; z <= 1; z++) {
            vec3 neighbor = vec3(float(x), float(y), float(z));
            vec3 cellPos = i + neighbor;
            
            vec3 randomOffset = vec3(
              hash(cellPos),
              hash(cellPos + vec3(31.0, 17.0, 23.0)),
              hash(cellPos + vec3(47.0, 53.0, 59.0))
            );
            
            vec3 grainPos = neighbor + randomOffset - f;
            vec3 grainScale = vec3(1.0, 0.4, 1.0);
            float dist = length(grainPos * grainScale);
            
            if(dist < minDist) {
              minDist = dist;
              minPoint = cellPos;
            }
          }
        }
      }
      
      return minDist;
    }
    
    // Generate wheat grain color
    vec3 getWheatColor(vec3 pos) {
      vec3 wheatLight = vec3(0.95, 0.85, 0.55);
      vec3 wheatMid = vec3(0.85, 0.70, 0.35);
      vec3 wheatDark = vec3(0.65, 0.50, 0.25);
      vec3 wheatShadow = vec3(0.45, 0.35, 0.20);
      
      float grainScale = 0.15;
      float grain = wheatGrains(pos, grainScale);
      float noiseVal = fbm(pos * grainScale * 2.0);
      
      float grainEdge = smoothstep(0.3, 0.5, grain);
      float grainCenter = 1.0 - smoothstep(0.0, 0.3, grain);
      float colorVar = hash(floor(pos * grainScale));
      
      vec3 grainColor = mix(wheatMid, wheatLight, grainCenter * 0.7);
      grainColor = mix(grainColor, wheatDark, grainEdge * 0.5);
      grainColor = mix(grainColor, wheatLight, colorVar * 0.3);
      grainColor = mix(grainColor, wheatDark, (1.0 - colorVar) * 0.2);
      grainColor *= 0.85 + noiseVal * 0.3;
      
      float groove = smoothstep(0.4, 0.5, grain);
      grainColor = mix(grainColor, wheatShadow, groove * 0.6);
      
      return grainColor;
    }
    
    void main() {
      // Get both material colors
      vec3 wheatColor = getWheatColor(vWorldPosition);
      vec3 stripColor = vec3(0.6, 0.6, 0.4); // 0x999966
      
      // Apply lighting
      vec3 lightDir = normalize(vec3(0.5, 1.0, 0.5));
      float diffuse = max(dot(normalize(vNormal), lightDir), 0.6);
      
      vec3 finalColor;
      
      // Check if transition is complete or not started
      if(transitionProgress <= 0.01) {
        // No transition - show current material directly
        if(useWheatMaterial > 0.5) {
          finalColor = wheatColor * diffuse;
        } else {
          finalColor = stripColor * diffuse;
        }
      } else if(transitionProgress >= 0.99) {
        // Transition complete - show target material
        if(useWheatMaterial > 0.5) {
          finalColor = wheatColor * diffuse;
        } else {
          finalColor = stripColor * diffuse;
        }
      } else {
        // During transition - blend based on height
        float heightRange = modelMaxY - modelMinY;
        float normalizedHeight = clamp((vWorldPosition.y - modelMinY) / heightRange, 0.0, 1.0);
        
        // Apply direction (1 = bottom-up, -1 = top-down)
        if(transitionDirection < 0.0) {
          normalizedHeight = 1.0 - normalizedHeight;
        }
        
        // Add noise to transition edge
        float edgeNoise = noise(vWorldPosition * 0.1) * 0.1;
        
        // Calculate transition threshold
        float transitionThreshold = transitionProgress * 1.2;
        float transitionEdge = smoothstep(transitionThreshold - 0.1 - edgeNoise, transitionThreshold + 0.05 + edgeNoise, normalizedHeight);
        
        // Blend factor based on target material
        float blendFactor;
        if(useWheatMaterial > 0.5) {
          // Transitioning TO wheat
          blendFactor = 1.0 - transitionEdge;
        } else {
          // Transitioning TO strip
          blendFactor = transitionEdge;
        }
        
        vec3 blendedColor = mix(stripColor, wheatColor, blendFactor);
        finalColor = blendedColor * diffuse;
      }
      
      gl_FragColor = vec4(finalColor, 1.0);
    }
  `,
  transparent: false,
  depthWrite: true,
  depthTest: true,
  polygonOffset: true,
  polygonOffsetFactor: 1,
  polygonOffsetUnits: 1
});

// Store global reference for material toggle
coneMaterialGlobal = coneMaterial;

//底部圆锥
var cone111 = new Three.Mesh(
        new Three.ConeGeometry(w_length,w_xiazhui*2,400),
        coneMaterial
)
cone111.rotation.x = Math.PI
cone111.position.y -=w_xiazhui
cone111.renderOrder = 0;  // Render first (before transparent outline)

//this.scene.add(cube111)


cube111.position.set(0,w_height,0)


console.log(down_flag)
cone111.scale.set(0.98,1,0.98)
cube111.scale.set(0.98,1,0.98)

if(down_flag){

  // 方案：创建完整的粮食几何体，包括顶面（粮面）和侧面（连接到圆锥）
  
  // 1. 获取边缘顶点（Delaunay 三角剖分的凸包）
  const hullIndices = indexDelaunay.hull;
  
  // 2. 创建完整的粮食几何体：顶面 + 侧面
  const grainPositions = [];
  const grainIndices = [];
  
  // 计算 mesh0 的变换参数
  const meshPosX = mesh0.position.x;
  const meshPosY = mesh0.position.y;
  const meshPosZ = mesh0.position.z;
  const meshScaleX = mesh0.scale.x;
  const meshScaleY = mesh0.scale.y;
  const meshScaleZ = mesh0.scale.z;
  
  // 圆锥参数
  const coneHeight = w_xiazhui * 2;
  const coneRadius = w_length * 0.98;  // 圆锥底面半径（考虑缩放）
  
  // 辅助函数：将点限制在圆锥内部
  function clampToCone(x, y, z) {
    const distFromAxis = Math.sqrt(x * x + z * z);
    // 圆锥在该高度的半径：y=0时半径=coneRadius，y=-coneHeight时半径=0
    // radiusAtY = coneRadius * (1 + y / coneHeight)，其中 y 是负数
    const radiusAtY = coneRadius * Math.max(0, 1 + y / coneHeight);
    
    if (distFromAxis > radiusAtY && distFromAxis > 0) {
      // 将点投影到圆锥表面
      const scale = radiusAtY / distFromAxis;
      return { x: x * scale, y: y, z: z * scale };
    }
    return { x, y, z };
  }
  
  // 添加顶面顶点（应用变换后的世界坐标，并限制在圆锥内）
  for (let i = 0; i < indexArr.length; i++) {
    let worldX = indexArr[i].x * meshScaleX + meshPosX;
    let worldY = indexArr[i].y * meshScaleY + meshPosY;
    let worldZ = indexArr[i].z * meshScaleZ + meshPosZ;
    
    // 将顶点限制在圆锥内
    const clamped = clampToCone(worldX, worldY, worldZ);
    grainPositions.push(clamped.x, clamped.y, clamped.z);
  }
  const topVertexCount = indexArr.length;
  
  // 添加顶面三角形索引
  for (let i = 0; i < meshIndex.length; i++) {
    grainIndices.push(meshIndex[i]);
  }
  
  // 3. 添加圆锥尖端作为底部中心点
  // cone111 配置：底面在 y=0，尖端在 y=-coneHeight
  const coneApexIndex = topVertexCount;
  grainPositions.push(0, -coneHeight, 0);  // 圆锥尖端（朝下）
  
  // 4. 添加侧面三角形（从粮面边缘连接到圆锥尖端，形成扇形）
  for (let i = 0; i < hullIndices.length; i++) {
    const topIdx1 = hullIndices[i];
    const topIdx2 = hullIndices[(i + 1) % hullIndices.length];
    
    // 每个侧面是一个三角形：两个相邻边缘顶点 + 圆锥尖端
    grainIndices.push(topIdx1, coneApexIndex, topIdx2);
  }
  
  // 5. 创建完整的粮食几何体
  const grainGeometry = new Three.BufferGeometry();
  grainGeometry.setAttribute('position', new Three.Float32BufferAttribute(grainPositions, 3));
  grainGeometry.setIndex(grainIndices);
  grainGeometry.computeVertexNormals();
  
  // 创建粮食 mesh（使用世界坐标，不需要额外变换）
  const grainSurfaceMesh = new Three.Mesh(
    grainGeometry,
    new Three.MeshBasicMaterial({ 
      color: 0xFF6600, 
      side: Three.DoubleSide,
      depthWrite: true,
      depthTest: true
    })
  );
  
  // 位置已经是世界坐标，不需要额外设置
  grainSurfaceMesh.position.set(0, 0, 0);
  grainSurfaceMesh.scale.set(1, 1, 1);
  
  // 创建粮食材质（高度渐变颜色）
  // 由于几何体已经包含侧面并且顶点已经是世界坐标，不需要圆锥裁剪
  const grainMaterial = new Three.ShaderMaterial({
    uniforms: {
      coneRadius: { value: w_length * 0.98 },  // 圆锥底面半径
      coneHeight: { value: w_xiazhui * 2 },  // 圆锥高度
      minY: { value: minY - this.kuan },
      maxY: { value: maxY - this.kuan },
      colorCold1: { value: new Three.Color(0.0, 0.2, 0.8) },
      colorCold2: { value: new Three.Color(0.0, 0.5, 0.9) },
      colorNeutral: { value: new Three.Color(0.7, 0.7, 0.7) },
      colorWarm1: { value: new Three.Color(0.9, 0.5, 0.0) },
      colorWarm2: { value: new Three.Color(1.0, 0.2, 0.0) }
    },
    vertexShader: `
      varying vec3 vWorldPosition;
      varying vec3 vNormal;
      
      void main() {
        // 顶点已经是世界坐标
        vWorldPosition = position;
        vNormal = normalize(normal);
        gl_Position = projectionMatrix * viewMatrix * vec4(position, 1.0);
      }
    `,
    fragmentShader: `
      uniform float coneRadius;
      uniform float coneHeight;
      uniform float minY;
      uniform float maxY;
      uniform vec3 colorCold1;
      uniform vec3 colorCold2;
      uniform vec3 colorNeutral;
      uniform vec3 colorWarm1;
      uniform vec3 colorWarm2;
      
      varying vec3 vWorldPosition;
      varying vec3 vNormal;
      
      void main() {
        float y = vWorldPosition.y;
        
        // 高度渐变颜色
        float heightT = clamp((y - minY) / (maxY - minY), 0.0, 1.0);
        heightT = smoothstep(0.0, 1.0, heightT);
        
        vec3 gradientColor;
        if(heightT < 0.25) {
          gradientColor = mix(colorCold1, colorCold2, heightT * 4.0);
        } else if(heightT < 0.5) {
          gradientColor = mix(colorCold2, colorNeutral, (heightT - 0.25) * 4.0);
        } else if(heightT < 0.75) {
          gradientColor = mix(colorNeutral, colorWarm1, (heightT - 0.5) * 4.0);
        } else {
          gradientColor = mix(colorWarm1, colorWarm2, (heightT - 0.75) * 4.0);
        }
        
        // 简单光照
        vec3 lightDir = normalize(vec3(0.5, 1.0, 0.5));
        float diffuse = max(dot(normalize(vNormal), lightDir), 0.5);
        
        gl_FragColor = vec4(gradientColor * diffuse, 1.0);
      }
    `,
    side: Three.DoubleSide,
    depthWrite: true,
    depthTest: true
  });
  
  grainSurfaceMesh.material = grainMaterial;
  
  // 使用粮面曲面作为meshResult
  meshResult = grainSurfaceMesh;

  // Calculate center point and dimensions of meshResult
  meshResult.geometry.computeBoundingBox();
	const center = new Three.Vector3();
	meshResult.geometry.boundingBox.getCenter(center);
	const size = new Three.Vector3();
	meshResult.geometry.boundingBox.getSize(size);
	const maxDimension = Math.max(size.x, size.y, size.z);

  // Load textures for below minY area
  const textureLoader = new Three.TextureLoader();
  const stripDiffuse = textureLoader.load('/hxc_model/strip_diffuse.jpg');
  const stripNormal = textureLoader.load('/hxc_model/strip_normal.jpg');
  
  // Set texture wrapping and repeat
  stripDiffuse.wrapS = stripDiffuse.wrapT = Three.RepeatWrapping;
  stripNormal.wrapS = stripNormal.wrapT = Three.RepeatWrapping;
  stripDiffuse.repeat.set(4, 4);
  stripNormal.repeat.set(4, 4);

  // Create shader material with height-based gradient from cool to warm colors
  // 添加圆锥裁剪参数（因为 down_flag 为 true，粮面在下锥内）
  gradientMaterial = new Three.ShaderMaterial({
					uniforms: {
						center: { value: center },
						maxHeight: { value: size.y },
						minY: { value: minY - this.kuan },  // Adjust for world space offset
						maxY: { value: maxY - this.kuan },  // Adjust for world space offset
						stripDiffuseMap: { value: stripDiffuse },
						stripNormalMap: { value: stripNormal },
						useWheatMaterial: { value: 0.0 },  // 0 = strip/gradient, 1 = wheat
						transitionProgress: { value: 0.0 },  // 0-1 transition progress
						transitionDirection: { value: 1.0 }, // 1 = bottom-up, -1 = top-down
						modelMinY: { value: minY - this.kuan },
						modelMaxY: { value: maxY - this.kuan },
						colorCold1: { value: new Three.Color(0.0, 0.2, 0.8) },    // Deep blue
						colorCold2: { value: new Three.Color(0.0, 0.5, 0.9) },    // Light blue
						colorNeutral: { value: new Three.Color(0.7, 0.7, 0.7) },  // Neutral gray
						colorWarm1: { value: new Three.Color(0.9, 0.5, 0.0) },    // Orange
						colorWarm2: { value: new Three.Color(1.0, 0.2, 0.0) },    // Red
						// 圆锥裁剪参数（禁用，因为几何体已经包含正确的侧面）
						enableConeClip: { value: 0.0 },  // 0.0 = 禁用圆锥裁剪
						coneRadius: { value: w_length * 0.98 },  // 圆锥底面半径
						coneHeight: { value: w_xiazhui * 2 }  // 圆锥高度
					},
					vertexShader: `
						varying vec3 vPosition;
						varying float vActualY;
						varying vec2 vUv;
						varying vec3 vNormal;
						varying vec3 vWorldPosition;
																	
						void main() {
							vPosition = position;
							// 顶点已经是世界坐标，直接使用
							vActualY = position.y;
							vWorldPosition = position;
							vUv = vec2(position.x * 0.1, position.z * 0.1);
							vNormal = normalize(normal);
							gl_Position = projectionMatrix * viewMatrix * vec4(position, 1.0);
						}
					`,
					fragmentShader: `
						uniform vec3 center;
						uniform float maxHeight;
						uniform float minY;
						uniform float maxY;
						uniform sampler2D stripDiffuseMap;
						uniform sampler2D stripNormalMap;
						uniform float useWheatMaterial;
						uniform float transitionProgress;
						uniform float transitionDirection;
						uniform float modelMinY;
						uniform float modelMaxY;
						uniform vec3 colorCold1;
						uniform vec3 colorCold2;
						uniform vec3 colorNeutral;
						uniform vec3 colorWarm1;
						uniform vec3 colorWarm2;
						// 圆锥裁剪参数
						uniform float enableConeClip;
						uniform float coneRadius;
						uniform float coneHeight;
						varying vec3 vPosition;
						varying float vActualY;
						varying vec2 vUv;
						varying vec3 vNormal;
						varying vec3 vWorldPosition;
						
						// 圆锥裁剪函数
						// 圆锥配置：尖端在 y=0，底面（开口）在 y=-coneHeight，半径=coneRadius
						bool isInsideCone(vec3 pos) {
							float y = pos.y;
							float distFromAxis = length(pos.xz);
							// y = 0 时（尖端）半径 = 0, y = -coneHeight 时（底面）半径 = coneRadius
							float t = clamp(-y / coneHeight, 0.0, 1.0);
							float radiusAtY = coneRadius * t;  // 从尖端到底面，半径线性增加
							return distFromAxis <= radiusAtY * 1.02;
						}
						
						// Hash function for randomness
						float hash(vec3 p) {
							p = fract(p * 0.3183099 + 0.1);
							p *= 17.0;
							return fract(p.x * p.y * p.z * (p.x + p.y + p.z));
						}
						
						// 3D Noise function
						float noise(vec3 x) {
							vec3 i = floor(x);
							vec3 f = fract(x);
							f = f * f * (3.0 - 2.0 * f);
							
							return mix(mix(mix(hash(i + vec3(0,0,0)), hash(i + vec3(1,0,0)), f.x),
							               mix(hash(i + vec3(0,1,0)), hash(i + vec3(1,1,0)), f.x), f.y),
							           mix(mix(hash(i + vec3(0,0,1)), hash(i + vec3(1,0,1)), f.x),
							               mix(hash(i + vec3(0,1,1)), hash(i + vec3(1,1,1)), f.x), f.y), f.z);
						}
						
						// Fractal Brownian Motion
						float fbm(vec3 p) {
							float value = 0.0;
							float amplitude = 0.5;
							float frequency = 1.0;
							for(int i = 0; i < 4; i++) {
								value += amplitude * noise(p * frequency);
								amplitude *= 0.5;
								frequency *= 2.0;
							}
							return value;
						}
						
						// Voronoi-like pattern for wheat grains
						float wheatGrains(vec3 p, float scale) {
							p *= scale;
							vec3 i = floor(p);
							vec3 f = fract(p);
							
							float minDist = 1.0;
							
							for(int x = -1; x <= 1; x++) {
								for(int y = -1; y <= 1; y++) {
									for(int z = -1; z <= 1; z++) {
										vec3 neighbor = vec3(float(x), float(y), float(z));
										vec3 cellPos = i + neighbor;
										
										vec3 randomOffset = vec3(
											hash(cellPos),
											hash(cellPos + vec3(31.0, 17.0, 23.0)),
											hash(cellPos + vec3(47.0, 53.0, 59.0))
										);
										
										vec3 grainPos = neighbor + randomOffset - f;
										vec3 grainScale = vec3(1.0, 0.4, 1.0);
										float dist = length(grainPos * grainScale);
										
										if(dist < minDist) {
											minDist = dist;
										}
									}
								}
							}
							
							return minDist;
						}
						
						// Generate wheat grain color
						vec3 getWheatColor(vec3 pos) {
							vec3 wheatLight = vec3(0.95, 0.85, 0.55);
							vec3 wheatMid = vec3(0.85, 0.70, 0.35);
							vec3 wheatDark = vec3(0.65, 0.50, 0.25);
							vec3 wheatShadow = vec3(0.45, 0.35, 0.20);
							
							float grainScale = 0.15;
							float grain = wheatGrains(pos, grainScale);
							float noiseVal = fbm(pos * grainScale * 2.0);
							
							float grainEdge = smoothstep(0.3, 0.5, grain);
							float grainCenter = 1.0 - smoothstep(0.0, 0.3, grain);
							float colorVar = hash(floor(pos * grainScale));
							
							vec3 grainColor = mix(wheatMid, wheatLight, grainCenter * 0.7);
							grainColor = mix(grainColor, wheatDark, grainEdge * 0.5);
							grainColor = mix(grainColor, wheatLight, colorVar * 0.3);
							grainColor = mix(grainColor, wheatDark, (1.0 - colorVar) * 0.2);
							grainColor *= 0.85 + noiseVal * 0.3;
							
							float groove = smoothstep(0.4, 0.5, grain);
							grainColor = mix(grainColor, wheatShadow, groove * 0.6);
							
							return grainColor;
						}
						
						// Get strip/gradient color
						vec3 getStripGradientColor() {
							vec3 resultColor;
							vec3 lightDir = normalize(vec3(0.5, 1.0, 0.5));
							float diffuse = max(dot(normalize(vNormal), lightDir), 0.6);
							
							// Base color for below minY
							vec3 baseColor = vec3(0.6, 0.6, 0.4); // 0x999966
							
							// Use smooth transition at minY boundary to avoid z-fighting artifacts
							float boundaryBlend = smoothstep(minY - 1.0, minY + 1.0, vActualY);
							
							// Calculate gradient color for above minY
							float t = clamp((vActualY - minY) / (maxY - minY), 0.0, 1.0);
							t = smoothstep(0.0, 1.0, t);
							vec3 gradientColor;
							if(t < 0.25) {
								gradientColor = mix(colorCold1, colorCold2, t * 4.0);
							} else if(t < 0.5) {
								gradientColor = mix(colorCold2, colorNeutral, (t - 0.25) * 4.0);
							} else if(t < 0.75) {
								gradientColor = mix(colorNeutral, colorWarm1, (t - 0.5) * 4.0);
							} else {
								gradientColor = mix(colorWarm1, colorWarm2, (t - 0.75) * 4.0);
							}
							
							// Blend between base color and gradient color
							resultColor = mix(baseColor * diffuse, gradientColor, boundaryBlend);
							return resultColor;
						}
											
						void main() {
							// 圆锥裁剪：如果启用且像素在圆锥外则丢弃
							if(enableConeClip > 0.5 && !isInsideCone(vWorldPosition)) {
								discard;
							}
							
							vec3 finalColor;
							float finalOpacity = 1.0;
							
							// Get both material colors
							vec3 wheatColor = getWheatColor(vWorldPosition);
							vec3 lightDir = normalize(vec3(0.5, 1.0, 0.5));
							float diffuse = max(dot(normalize(vNormal), lightDir), 0.6);
							wheatColor *= diffuse;
							
							vec3 stripColor = getStripGradientColor();
							
							// Check if transition is complete or not started
							if(transitionProgress <= 0.01) {
								// No transition - show current material directly
								if(useWheatMaterial > 0.5) {
									finalColor = wheatColor;
								} else {
									finalColor = stripColor;
								}
							} else if(transitionProgress >= 0.99) {
								// Transition complete - show target material
								if(useWheatMaterial > 0.5) {
									finalColor = wheatColor;
								} else {
									finalColor = stripColor;
								}
							} else {
								// During transition - blend based on height
								float heightRange = modelMaxY - modelMinY;
								float normalizedHeight = clamp((vWorldPosition.y - modelMinY) / heightRange, 0.0, 1.0);
								
								// Apply direction (1 = bottom-up, -1 = top-down)
								if(transitionDirection < 0.0) {
									normalizedHeight = 1.0 - normalizedHeight;
								}
								
								// Add noise to transition edge
								float edgeNoise = noise(vWorldPosition * 0.1) * 0.1;
								
								// Calculate transition threshold
								float transitionThreshold = transitionProgress * 1.2;
								float transitionEdge = smoothstep(transitionThreshold - 0.1 - edgeNoise, transitionThreshold + 0.05 + edgeNoise, normalizedHeight);
								
								// Blend factor based on target material
								float blendFactor;
								if(useWheatMaterial > 0.5) {
									// Transitioning TO wheat
									blendFactor = 1.0 - transitionEdge;
								} else {
									// Transitioning TO strip
									blendFactor = transitionEdge;
								}
								
								finalColor = mix(stripColor, wheatColor, blendFactor);
							}
												
							gl_FragColor = vec4(finalColor, finalOpacity);
						}
					`,
					transparent: false,
					depthWrite: true,
					depthTest: true,
					polygonOffset: true,
					polygonOffsetFactor: -1,
					polygonOffsetUnits: -1
				});
				
				meshResult.material = gradientMaterial;
				meshResult.renderOrder = 1;  // Render after cone


  this.scene.add(meshResult)

  console.log('minY value (original):', minY);
  console.log('minY value (world space):', minY - this.kuan);
  console.log('maxY value (original):', maxY);
  console.log('maxY value (world space):', maxY - this.kuan);
  console.log('meshResult bounding box:', meshResult.geometry.boundingBox);


}else{
  console.log(11111)
  // 粮面跨入下锥时，CSG 结果自身会生成与下锥边界贴合的粮食侧面。
  // 此时不再叠加不透明的下锥填充体，否则会遮住下锥内的真实粮面。
  if (!crossesConeTop) {
    this.scene.add(cone111)
  }
  
  mesh0.updateMatrix()
  let clipMesh = cube111

  if (crossesConeTop && w_xiazhui > 0) {
    // 混合高度粮面必须与完整筒仓轮廓相交。
    // 如果仍只使用圆柱体，CSG 会把 Y<0 的部分切掉，并用圆柱底面封口，
    // 形成下锥顶口处的水平圆盘。
    clipMesh = new Three.Mesh(
      this.createRoundSiloClipGeometry(
        w_length * 0.98,
        w_height * 2,
        w_xiazhui * 2,
        100
      ),
      material111
    )
  }

  clipMesh.updateMatrix()
  let bspA = new CSG.fromMesh( mesh0 )
  let bspB = new CSG.fromMesh( clipMesh )
  let bspResult = bspA.intersect(bspB)
  meshResult = CSG.toMesh( bspResult, clipMesh.matrix, clipMesh.material )


  // Calculate center point and dimensions of meshResult
  meshResult.geometry.computeBoundingBox();
	const center = new Three.Vector3();
	meshResult.geometry.boundingBox.getCenter(center);
	const size = new Three.Vector3();
	meshResult.geometry.boundingBox.getSize(size);
	const maxDimension = Math.max(size.x, size.y, size.z);

  // Load textures for below minY area
  const textureLoader = new Three.TextureLoader();
  const stripDiffuse = textureLoader.load('/hxc_model/strip_diffuse.jpg');
  const stripNormal = textureLoader.load('/hxc_model/strip_normal.jpg');
  
  // Set texture wrapping and repeat
  stripDiffuse.wrapS = stripDiffuse.wrapT = Three.RepeatWrapping;
  stripNormal.wrapS = stripNormal.wrapT = Three.RepeatWrapping;
  stripDiffuse.repeat.set(4, 4);
  stripNormal.repeat.set(4, 4);

  // Create shader material with height-based gradient from cool to warm colors
  gradientMaterial = new Three.ShaderMaterial({
					uniforms: {
						center: { value: center },
						maxHeight: { value: size.y },
						minY: { value: minY - this.kuan },  // Adjust for world space offset
						maxY: { value: maxY - this.kuan },  // Adjust for world space offset
						stripDiffuseMap: { value: stripDiffuse },
						stripNormalMap: { value: stripNormal },
						useWheatMaterial: { value: 0.0 },  // 0 = strip/gradient, 1 = wheat
						transitionProgress: { value: 0.0 },  // 0-1 transition progress
						transitionDirection: { value: 1.0 }, // 1 = bottom-up, -1 = top-down
						modelMinY: { value: minY - this.kuan },
						modelMaxY: { value: maxY - this.kuan },
						colorCold1: { value: new Three.Color(0.0, 0.2, 0.8) },    // Deep blue
						colorCold2: { value: new Three.Color(0.0, 0.5, 0.9) },    // Light blue
						colorNeutral: { value: new Three.Color(0.7, 0.7, 0.7) },  // Neutral gray
						colorWarm1: { value: new Three.Color(0.9, 0.5, 0.0) },    // Orange
						colorWarm2: { value: new Three.Color(1.0, 0.2, 0.0) }     // Red
					},
					vertexShader: `
						varying vec3 vPosition;
						varying float vActualY;
						varying vec2 vUv;
						varying vec3 vNormal;
						varying vec3 vWorldPosition;
																	
						void main() {
							vPosition = position;
							vec4 worldPosition = modelMatrix * vec4(position, 1.0);
							vActualY = worldPosition.y;
							vWorldPosition = worldPosition.xyz;
							vUv = vec2(worldPosition.x * 0.1, worldPosition.z * 0.1);
							vNormal = normalize(normalMatrix * normal);
							gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
						}
					`,
					fragmentShader: `
						uniform vec3 center;
						uniform float maxHeight;
						uniform float minY;
						uniform float maxY;
						uniform sampler2D stripDiffuseMap;
						uniform sampler2D stripNormalMap;
						uniform float useWheatMaterial;
						uniform float transitionProgress;
						uniform float transitionDirection;
						uniform float modelMinY;
						uniform float modelMaxY;
						uniform vec3 colorCold1;
						uniform vec3 colorCold2;
						uniform vec3 colorNeutral;
						uniform vec3 colorWarm1;
						uniform vec3 colorWarm2;
						varying vec3 vPosition;
						varying float vActualY;
						varying vec2 vUv;
						varying vec3 vNormal;
						varying vec3 vWorldPosition;
						
						// Hash function for randomness
						float hash(vec3 p) {
							p = fract(p * 0.3183099 + 0.1);
							p *= 17.0;
							return fract(p.x * p.y * p.z * (p.x + p.y + p.z));
						}
						
						// 3D Noise function
						float noise(vec3 x) {
							vec3 i = floor(x);
							vec3 f = fract(x);
							f = f * f * (3.0 - 2.0 * f);
							
							return mix(mix(mix(hash(i + vec3(0,0,0)), hash(i + vec3(1,0,0)), f.x),
							               mix(hash(i + vec3(0,1,0)), hash(i + vec3(1,1,0)), f.x), f.y),
							           mix(mix(hash(i + vec3(0,0,1)), hash(i + vec3(1,0,1)), f.x),
							               mix(hash(i + vec3(0,1,1)), hash(i + vec3(1,1,1)), f.x), f.y), f.z);
						}
						
						// Fractal Brownian Motion
						float fbm(vec3 p) {
							float value = 0.0;
							float amplitude = 0.5;
							float frequency = 1.0;
							for(int i = 0; i < 4; i++) {
								value += amplitude * noise(p * frequency);
								amplitude *= 0.5;
								frequency *= 2.0;
							}
							return value;
						}
						
						// Voronoi-like pattern for wheat grains
						float wheatGrains(vec3 p, float scale) {
							p *= scale;
							vec3 i = floor(p);
							vec3 f = fract(p);
							
							float minDist = 1.0;
							
							for(int x = -1; x <= 1; x++) {
								for(int y = -1; y <= 1; y++) {
									for(int z = -1; z <= 1; z++) {
										vec3 neighbor = vec3(float(x), float(y), float(z));
										vec3 cellPos = i + neighbor;
										
										vec3 randomOffset = vec3(
											hash(cellPos),
											hash(cellPos + vec3(31.0, 17.0, 23.0)),
											hash(cellPos + vec3(47.0, 53.0, 59.0))
										);
										
										vec3 grainPos = neighbor + randomOffset - f;
										vec3 grainScale = vec3(1.0, 0.4, 1.0);
										float dist = length(grainPos * grainScale);
										
										if(dist < minDist) {
											minDist = dist;
										}
									}
								}
							}
							
							return minDist;
						}
						
						// Generate wheat grain color
						vec3 getWheatColor(vec3 pos) {
							vec3 wheatLight = vec3(0.95, 0.85, 0.55);
							vec3 wheatMid = vec3(0.85, 0.70, 0.35);
							vec3 wheatDark = vec3(0.65, 0.50, 0.25);
							vec3 wheatShadow = vec3(0.45, 0.35, 0.20);
							
							float grainScale = 0.15;
							float grain = wheatGrains(pos, grainScale);
							float noiseVal = fbm(pos * grainScale * 2.0);
							
							float grainEdge = smoothstep(0.3, 0.5, grain);
							float grainCenter = 1.0 - smoothstep(0.0, 0.3, grain);
							float colorVar = hash(floor(pos * grainScale));
							
							vec3 grainColor = mix(wheatMid, wheatLight, grainCenter * 0.7);
							grainColor = mix(grainColor, wheatDark, grainEdge * 0.5);
							grainColor = mix(grainColor, wheatLight, colorVar * 0.3);
							grainColor = mix(grainColor, wheatDark, (1.0 - colorVar) * 0.2);
							grainColor *= 0.85 + noiseVal * 0.3;
							
							float groove = smoothstep(0.4, 0.5, grain);
							grainColor = mix(grainColor, wheatShadow, groove * 0.6);
							
							return grainColor;
						}
						
						// Get strip/gradient color
						vec3 getStripGradientColor() {
							vec3 resultColor;
							vec3 lightDir = normalize(vec3(0.5, 1.0, 0.5));
							float diffuse = max(dot(normalize(vNormal), lightDir), 0.6);
							
							// Base color for below minY
							vec3 baseColor = vec3(0.6, 0.6, 0.4); // 0x999966
							
							// Use smooth transition at minY boundary to avoid z-fighting artifacts
							float boundaryBlend = smoothstep(minY - 1.0, minY + 1.0, vActualY);
							
							// Calculate gradient color for above minY
							float t = clamp((vActualY - minY) / (maxY - minY), 0.0, 1.0);
							t = smoothstep(0.0, 1.0, t);
							vec3 gradientColor;
							if(t < 0.25) {
								gradientColor = mix(colorCold1, colorCold2, t * 4.0);
							} else if(t < 0.5) {
								gradientColor = mix(colorCold2, colorNeutral, (t - 0.25) * 4.0);
							} else if(t < 0.75) {
								gradientColor = mix(colorNeutral, colorWarm1, (t - 0.5) * 4.0);
							} else {
								gradientColor = mix(colorWarm1, colorWarm2, (t - 0.75) * 4.0);
							}
							
							// Blend between base color and gradient color
							resultColor = mix(baseColor * diffuse, gradientColor, boundaryBlend);
							return resultColor;
						}
											
						void main() {
							vec3 finalColor;
							float finalOpacity = 1.0;
							
							// Get both material colors
							vec3 wheatColor = getWheatColor(vWorldPosition);
							vec3 lightDir = normalize(vec3(0.5, 1.0, 0.5));
							float diffuse = max(dot(normalize(vNormal), lightDir), 0.6);
							wheatColor *= diffuse;
							
							vec3 stripColor = getStripGradientColor();
							
							// Check if transition is complete or not started
							if(transitionProgress <= 0.01) {
								// No transition - show current material directly
								if(useWheatMaterial > 0.5) {
									finalColor = wheatColor;
								} else {
									finalColor = stripColor;
								}
							} else if(transitionProgress >= 0.99) {
								// Transition complete - show target material
								if(useWheatMaterial > 0.5) {
									finalColor = wheatColor;
								} else {
									finalColor = stripColor;
								}
							} else {
								// During transition - blend based on height
								float heightRange = modelMaxY - modelMinY;
								float normalizedHeight = clamp((vWorldPosition.y - modelMinY) / heightRange, 0.0, 1.0);
								
								// Apply direction (1 = bottom-up, -1 = top-down)
								if(transitionDirection < 0.0) {
									normalizedHeight = 1.0 - normalizedHeight;
								}
								
								// Add noise to transition edge
								float edgeNoise = noise(vWorldPosition * 0.1) * 0.1;
								
								// Calculate transition threshold
								float transitionThreshold = transitionProgress * 1.2;
								float transitionEdge = smoothstep(transitionThreshold - 0.1 - edgeNoise, transitionThreshold + 0.05 + edgeNoise, normalizedHeight);
								
								// Blend factor based on target material
								float blendFactor;
								if(useWheatMaterial > 0.5) {
									// Transitioning TO wheat
									blendFactor = 1.0 - transitionEdge;
								} else {
									// Transitioning TO strip
									blendFactor = transitionEdge;
								}
								
								finalColor = mix(stripColor, wheatColor, blendFactor);
							}
												
							gl_FragColor = vec4(finalColor, finalOpacity);
						}
					`,
					transparent: false,
					depthWrite: true,
					depthTest: true,
					polygonOffset: true,
					polygonOffsetFactor: -1,
					polygonOffsetUnits: -1
				});
				
				meshResult.material = gradientMaterial;
				meshResult.renderOrder = 1;  // Render after cone
  this.scene.add(meshResult)
  
  console.log('minY value (original):', minY);
  console.log('minY value (world space):', minY - this.kuan);
  console.log('maxY value (original):', maxY);
  console.log('maxY value (world space):', maxY - this.kuan);
  console.log('meshResult bounding box:', meshResult.geometry.boundingBox);
  //meshResult.position.set(-w_length, 0, -w_length)
  
}

// Load error data if available
if (this.errorData) {
  this.loadErrorData(w_width, w_length);
}

}
      

        

    },

    // Load and display error data
    loadErrorData(w_width, w_length) {
      if (!this.errorData || !this.errorData.all_anomalies) return;

      // Clear existing error data
      if (errorAnomalies) {
        errorAnomalies.forEach(anomaly => {
          this.scene.remove(anomaly);
        });
      }
      if (errorPoints) {
        errorPoints.forEach(points => {
          this.scene.remove(points);
        });
      }
      errorAnomalies = [];
      errorPoints = [];

      // Process each anomaly
      this.errorData.all_anomalies.forEach((anomaly, index) => {
        // Create point cloud for anomaly
        this.createAnomalyPoints(anomaly, index, w_width, w_length);
      });

      // Set initial visibility based on checkbox state
      this.onToggleErrorData();
    },

    // Create point cloud for anomaly
    createAnomalyPoints(anomaly, index, w_width, w_length) {
      if (!anomaly.points || anomaly.points.length === 0) return;

      // Color palette for different anomaly areas
      const colorPalette = [
        0xff0000, 0x00ff00, 0x0000ff, 0xffff00, 0xff00ff, 0x00ffff,
        0xff8000, 0x8000ff, 0x00ff80, 0xff0080, 0x80ff00, 0x0080ff,
        0xff4000, 0x4000ff, 0x00ff40, 0xff0040, 0x40ff00, 0x0040ff,
        0xff8080, 0x80ff80
      ];

      // Select color based on anomaly index
      const color = new Three.Color(colorPalette[index % colorPalette.length]);

      // Create geometry for points
      const geometry = new Three.BufferGeometry();
      const positions = [];
      const colors = [];

      anomaly.points.forEach(point => {
        // Convert coordinates to match the scene coordinate system
        const x = point[0] - w_width;
        const y = point[2]; // Use Z as Y (height)
        const z = point[1] - w_length;

        positions.push(x, y, z);
        colors.push(color.r, color.g, color.b);
      });

      geometry.setAttribute('position', new Three.Float32BufferAttribute(positions, 3));
      geometry.setAttribute('color', new Three.Float32BufferAttribute(colors, 3));

      // Create material for points
      const material = new Three.PointsMaterial({
        size: 2,
        vertexColors: true,
        transparent: true,
        opacity: 0.8
      });

      // Create points object
      const points = new Three.Points(geometry, material);
      points.name = `anomaly_points_${index}`;

      // Add to scene and track
      this.scene.add(points);
      errorPoints.push(points);
    },

    // 加载 HDR 环境贴图（夜空），并设置为场景背景和环境光照
    loadEnvironmentMap() {
      const that = this;
      const textureLoader = new Three.TextureLoader();
      textureLoader.load(
        '/hxc_model/NightSkyHDRI001_2K/NightSkyHDRI003_8K_TONEMAPPED.jpg',
        function (texture) {
          // 等矩矩形映射 (球形全景)
          texture.mapping = Three.EquirectangularReflectionMapping;
          texture.colorSpace = Three.SRGBColorSpace || Three.sRGBEncoding;

          // 使用 PMREMGenerator 生成环境反射贴图
          const pmrem = new Three.PMREMGenerator(that.renderer);
          pmrem.compileEquirectangularShader();
          const envMap = pmrem.fromEquirectangular(texture).texture;

          that.scene.background = texture;  // 直接用原始贴图作为背景
          that.scene.environment = envMap;  // PMREM 用于 PBR 材质反射

          texture.dispose();
          pmrem.dispose();
          console.log('HDR environment map loaded');
        },
        undefined,
        function (err) {
          console.error('Failed to load environment map:', err);
        }
      );
    },

    // 创建环绕场景的炫酷流光效果
    // 包含：动态网格、向外扩散的能量环、背景噪点微粒子闪烁、边缘淡出
    createFlowLightEffect() {
      // 地面尺寸：以仓房最大边长的 8 倍作为流光效果覆盖范围
      const baseSize = Math.max(this.chang, this.kuan) * 8;

      const flowGeometry = new Three.PlaneGeometry(baseSize, baseSize, 1, 1);

      const flowMaterial = new Three.ShaderMaterial({
        uniforms: {
          time: { value: 0.0 },
          baseColor:  { value: new Three.Color(0x0a1a30) }, // 深蓝底色
          gridColor:  { value: new Three.Color(0x00ffff) }, // 青蓝网格
          pulseColor: { value: new Three.Color(0x0a3a8c) }  // 深邂科技蓝能量环
        },
        vertexShader: `
          varying vec2 vUv;
          varying vec3 vWorldPos;
          void main() {
            vUv = uv;
            vec4 worldPos = modelMatrix * vec4(position, 1.0);
            vWorldPos = worldPos.xyz;
            gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
          }
        `,
        fragmentShader: `
          uniform float time;
          uniform vec3 baseColor;
          uniform vec3 gridColor;
          uniform vec3 pulseColor;
          varying vec2 vUv;
          varying vec3 vWorldPos;

          float hash(vec2 p) {
            return fract(sin(dot(p, vec2(127.1, 311.7))) * 43758.5453);
          }

          float noise(vec2 p) {
            vec2 i = floor(p);
            vec2 f = fract(p);
            f = f * f * (3.0 - 2.0 * f);
            float a = hash(i);
            float b = hash(i + vec2(1.0, 0.0));
            float c = hash(i + vec2(0.0, 1.0));
            float d = hash(i + vec2(1.0, 1.0));
            return mix(mix(a, b, f.x), mix(c, d, f.x), f.y);
          }

          void main() {
            vec2 uv = vUv - 0.5;
            float dist = length(uv);
            float ang  = atan(uv.y, uv.x);

            vec3 color = baseColor;

            // 1) 动态网格：水平/垂直线
            vec2 gridUV = vUv * 40.0;
            vec2 gridAxis = abs(fract(gridUV - 0.5) - 0.5);
            float gridLine = 1.0 - smoothstep(0.0, 0.04, min(gridAxis.x, gridAxis.y));
            float gridPulse = 0.5 + 0.5 * sin(time * 2.0 - dist * 20.0);
            color += gridColor * gridLine * (0.3 + gridPulse * 0.5) * smoothstep(0.5, 0.05, dist);

            // 2) 向外扩散的能量环
            for (int i = 0; i < 3; i++) {
              float fi = float(i);
              float ringPhase = fract(time * 0.3 + fi * 0.33);
              float ringRadius = ringPhase * 0.7;
              float ringAlpha = (1.0 - ringPhase) * (1.0 - ringPhase);
              float ringWidth = 0.001;

              float ringCore = smoothstep(ringWidth, 0.0, abs(dist - ringRadius));
              float glowDist = abs(dist - ringRadius);
              float ringGlowWide = exp(-glowDist * 55.0);
              float ringGlowSoft = exp(-glowDist * 22.0);

              vec3 highlight = vec3(0.7, 0.9, 1.0);
              vec3 deepCore  = pulseColor * 1.4;
              vec3 outerGlow = pulseColor * 0.8;

              color += highlight * ringCore * ringAlpha * 1.3;
              color += deepCore  * ringGlowWide * ringAlpha * 0.8;
              color += outerGlow * ringGlowSoft * ringAlpha * 0.4;
            }

            // 3) 背景噪点微粒子闪烁
            float twinkle = noise(vUv * 120.0 + time * 0.5);
            float sparkle = smoothstep(0.92, 1.0, twinkle) * (0.5 + 0.5 * sin(time * 8.0 + twinkle * 30.0));
            color += vec3(0.4, 0.7, 1.0) * sparkle * 0.8;

            // 4) 边缘淡出
            float edgeFade = smoothstep(0.5, 0.15, dist);
            color *= edgeFade;

            // 中心圆盘在仓房下方隐藏
            float centerMask = smoothstep(0.0, 0.08, dist);
            color *= centerMask;

            gl_FragColor = vec4(color, edgeFade * 0.95);
          }
        `,
        transparent: true,
        depthWrite: false,
        side: Three.DoubleSide,
        blending: Three.AdditiveBlending
      });

      const flowPlane = new Three.Mesh(flowGeometry, flowMaterial);
      flowPlane.rotation.x = -Math.PI / 2;   // 水平放置
      // 始终位于场景最下方：
      // - 下锥存在时（!isConsole），下锥尖端 y = -2 * (kuan * 0.5) = -kuan
      // - 同时考虑 xiazhui 属性，取两者的最低值，再额外下沉一段距离
      const coneBottomY = this.isConsole ? 0 : -this.kuan;
      const xiazhuiBottomY = -(this.xiazhui || 0);
      flowPlane.position.y = Math.min(coneBottomY, xiazhuiBottomY) - 20;
      flowPlane.renderOrder = -1;
      this.scene.add(flowPlane);

      // 同时更新背景色，增强流光对比度
      this.renderer.setClearColor(0x050810);

      this.flowLightMaterial = flowMaterial;
      this.flowClock = new Three.Clock();
    },

  }, 
  computed: {},
  watch: {
    screenWidth() {
      if (!this.timer) {
        this.timer = true;
        setTimeout(() => {
          this.camera = null;
          this.scene = null;
          this.renderer = null;
          this.mesh = null;
          this.timer = false;
          this.init();
          this.renderScene();
        }, 1000);
      }
    },

    datas:{
      handler:function () {
                      if (this.normalizePointData(this.datas).length !== 0) {
                      this.init();
                      this.renderScene();
                    }
                },
      
    }
  },
  created() {},
  mounted() {

    console.log("chang:",this.chang)
    console.log("kuan:",this.kuan)
    console.log("gao:",this.gao)

    if (this.normalizePointData(this.datas).length !== 0) {
      this.init();
      this.renderScene();
      if(this.isConsole){
        container.addEventListener( 'click', this.onDocumentMouseDown );
      }
    }
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth;
      })();
    };
  },
};
</script>

<style lang="scss" scoped>
#three {
  width: 100%;
  height: 100%;
  position: relative;
}
</style>
